import React, { memo } from 'react'
import { Link } from 'transfix-ui/core'
import { IShipment, IStopsSummary } from 'types'
import { formatCurrency } from 'utils/formatCurrency'
import { stopsSummary } from 'utils/shipmentHelpers'

const ShipmentRow = memo<{ shipment: IShipment }>(({ shipment }) => {
  const { delivery, pickup } = stopsSummary(shipment) as IStopsSummary
  const { driverName, driverParentUserId, shipperId, shipperName } = shipment.users

  return (
    <tr data-test={`shipment-${shipment.id}`}>
      <td>
        <Link
          href={`${__ROOT__}/shipment-details/${shipment.id}`}
          target='_blank'
          rel='noopener noreferrer'>
          {shipment.id}
        </Link>
      </td>
      <td>{shipment.equipment.name}</td>
      {pickup && (
        <>
          <td>{pickup.dateTimestamp}</td>
          <td>
            {pickup.city}, {pickup.state}
          </td>
        </>
      )}
      {delivery && (
        <td>
          {delivery.city}, {delivery.state}
        </td>
      )}
      <td>{formatCurrency(shipment.rates.shipperRate, true)}</td>
      <td>{formatCurrency(shipment.rates.carrierRate, true)}</td>
      <td>
        <Link href={`${__ROOT__}/shippers/${shipperId}`} target='_blank' rel='noopener noreferrer'>
          {shipperName}
        </Link>
      </td>
      <td>
        {shipment.status.name} {shipment.info.hasClaims ? '(Claims)' : ''}
      </td>
      <td>
        <Link
          href={`${__ROOT__}/users/${driverParentUserId}`}
          target='_blank'
          rel='noopener noreferrer'>
          {driverName}
        </Link>
      </td>
    </tr>
  )
})

export default ShipmentRow
